/** @jsx jsx */
import React from 'react';
import { css, jsx } from '@emotion/core';
import { grayScale, utilityColor } from 'components/styles';
import CircleIconButton from 'components/molecules/CircleIconButton';
import {
  isSafari,
} from 'react-device-detect';
import { PaginationProps } from './Pagination';
import GlobalFilter, { GlobalFilterProps } from './GlobalFilter';

const styles = {
  controllbar: css({
    display: 'flex',
    width: 'fit-content',
    alignItems: 'center',
    padding: '8px 0'
  }),
  controllbarRight: css({
    display: 'flex',
    alignItems: 'center',
    width: 'fit-content',
    padding: '8px 0',
    justifyContent: 'space-between',
    marginRight: '20px'
  }),
  actionButton: css({
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  },
    isSafari
      ? css`
    .input-search {
      width: 240px
    }
    .input-search input{
      height: 38px;
      padding: 0;
      width: 100%
    }
    button{
      margin-left: -10px
    }
  `
      : css`
      .input-search {
        width: 210px
      }
    .input-search input{
      height:38px;
      padding: 0;
      width: 100%
    }
    button{
      margin-left:-15px
    }
`),
  pagenation: css({
    marginLeft: 'auto',
  }),
};

interface ControllbarProps {
  pagination: PaginationProps;
  filter: GlobalFilterProps;
  iconSize?: string;
  isGlobalFilter: boolean;
  tableId: number;
  globalSearchStyle?: any,
  searchRight?: boolean
}

const Controllbar: React.FC<ControllbarProps> = ({
  pagination, filter, isGlobalFilter, tableId, globalSearchStyle, iconSize, searchRight = false
}) => (
    <div css={searchRight === true ? styles.controllbarRight : styles.controllbar}>
      <div></div>
      {
        isGlobalFilter ? (
          <div css={css({
            minWidth: '290px', border: '1px solid #dcdcdc', backgroundColor: '#ffffff', borderRadius: '50px', marginLeft: '20px', marginBottom: '14px', marginTop: '14px',
          }, globalSearchStyle)}
          >
            <div css={styles.actionButton}>
              <CircleIconButton
                iconSize={iconSize}
                iconType="search"
                iconColor={grayScale.gray100}
                borderColor={utilityColor.transparent}
                onClick={() => console.log('検索')}
              />
              <GlobalFilter
                state={filter.state}
                setGlobalFilter={filter.setGlobalFilter}
                tableId={tableId}
              />
            </div>
          </div>
        ) : ''
      }
      {/* <div css={styles.actionButton}>
      <CircleIconButton
        iconType="filter"
        iconColor={grayScale.gray100}
        borderColor={utilityColor.transparent}
        onClick={() => console.log('フィルター')}
      />
    </div>*/}
      {/* <div css={styles.pagenation}>
      <Pagenation
        total={pagination.total}
        pageSize={pagination.pageSize}
        pageIndex={pagination.pageIndex}
        pageCount={pagination.pageCount}
        nextPage={pagination.nextPage}
        canNextPage={pagination.canNextPage}
        previousPage={pagination.previousPage}
        canPreviousPage={pagination.canPreviousPage}
        setPageSize={pagination.setPageSize}
        gotoPage={pagination.gotoPage}
        tableId={tableId}
      />
    </div> */}
    </div>
  );

export default Controllbar;
